import type { IEquipmentDetails } from '@model/equipmentDetails';

export const getDetailsData = (
  t: (text: string) => string,
  equipmentDetails?: IEquipmentDetails,
  type?: string,
) => {
  if (!equipmentDetails) {
    return [];
  }

  if (type === 'gateway') {
    return [
      `${t('Installation Point')}: ${t('Waites Gateway')}`,
      `${t('Gateway Serial')}: ${equipmentDetails.serial || '-'}`,
      `${t('Location')}: ${equipmentDetails.locationTable?.name || '-'} (location_id: ${
        equipmentDetails.location_id || '-'
      })`,
      `${t('Facility Name')}: ${equipmentDetails.facility?.name || '-'} (facility_id: ${
        equipmentDetails.facility?.facility_id || '-'
      })`,
      `${t('Asset Code')}: ${equipmentDetails.wo_asset_id || '-'}`,
    ];
  }

  if (type === 'router') {
    return [
      `${t('Installation Point')}: ${t('Waites Repeater')}`,
      `${t('Repeater Serial')}: ${equipmentDetails.serial || '-'}`,
      `${t('Gateway Serial Number')}: ${equipmentDetails.gateway?.serial || '-'}`,
      `${t('Location')}: ${equipmentDetails.location?.name || '-'} (location_id: ${
        equipmentDetails.location_id || '-'
      })`,
      `${t('Facility Name')}: ${equipmentDetails.gateway?.facility?.name || '-'} (facility_id: ${
        equipmentDetails.gateway?.facility?.facility_id || '-'
      })`,
      `${t('Asset Code')}: ${equipmentDetails.wo_asset_id || '-'}`,
    ];
  }

  if (type === 'tachometer') {
    return [
      `${t('Component')}: ${equipmentDetails.component || '-'}`,
      `${t('Serial')}: ${equipmentDetails.serial || '-'}`,
      `${t('Location')}: ${equipmentDetails.equipment?.locationTable?.name || '-'} (location_id: ${
        equipmentDetails.equipment?.locationTable?.id || '-'
      })`,
      `${t('Equipment')}: ${equipmentDetails.equipment?.name || '-'} (equipment_id: ${
        equipmentDetails.equipment_id || '-'
      })`,
      `${t('Facility Name')}: ${
        equipmentDetails.equipment?.locationTable?.facility?.name || '-'
      } (facility_id: ${equipmentDetails.equipment?.locationTable?.facility?.facility_id || '-'})`,
      `${t('Node Serial Number')}: ${equipmentDetails.sensor?.node?.serial || '-'}`,
      `${t('Asset Code')}: ${equipmentDetails.equipment?.asset_code || '-'}`,
    ];
  }

  if (type === 'node') {
    return [
      `${t('Installation Point')}: ${t('Waites Node')}`,
      `${t('Node Serial')}: ${equipmentDetails.serial || '-'}`,
      `${t('Gateway Serial Number')}: ${equipmentDetails.gateway?.serial || '-'}`,
      `${t('Location')}: ${equipmentDetails.locationTable?.name || '-'} (location_id: ${
        equipmentDetails.locationTable?.id || '-'
      })`,
      `${t('Facility Name')}: ${equipmentDetails.gateway?.facility?.name || '-'} (facility_id: ${
        equipmentDetails.gateway?.facility?.facility_id || '-'
      })`,
      `${t('Asset Code')}: ${equipmentDetails.wo_asset_id || '-'}`,
    ];
  }

  return [];
};
